// @vendors
import { useEffect, useState } from "react";
import { gsap } from "gsap";
import { ScrollToPlugin } from 'gsap/dist/ScrollToPlugin';
// @styles 
import './styles.scss'
import { Fade } from "react-reveal";

gsap.registerPlugin(ScrollToPlugin);

export default function Questions({ data, handleChange }) {
    const [openMore, setOpenMore] = useState(false);
    const [elements, setElements] = useState([]);
    const info = data.primary
    const items = data.items

    useEffect(() => { setElements(openMore ? items : items.slice(0, 3)) }, []);

    const changeView = () => {
        setOpenMore(!openMore);
        setElements(!openMore ? items : items.slice(0, 3));
        if (openMore) {
            gsap.to(window, { duration: 0, scrollTo: { y: '#' + info.idcontent, offsetY: 0 } });
        }
    }

    const getAnswer = (value) => {
        let answer = '';
        if (value && value.includes('*aquí*')) {
            answer = value.split('*').map((item) => (item === 'aquí' ?
                <a onClick={() => handleChange(null)}>{item}</a> :
                <span dangerouslySetInnerHTML={{ __html: item }} />));
        } else {
            answer = <td dangerouslySetInnerHTML={{ __html: value ? value : "" }} />
        }
        return answer
    }

    return (
        <div className='questions__container' id={info.idcontent}>
            <div className="container-xl">
                <div className='questions__container-content'>
                    {info.sectiontitle && (
                        <Fade left delay={0.3}>
                            <div className='homepage__container-title center-title'>
                                <p>{info.sectiontitle ? info.sectiontitle : ""}</p>
                            </div>
                        </Fade>
                    )}
                    <div className="questions__container-content__list">
                        <ul>
                            {elements && elements.length > 0 && elements.map((item, index) => (
                                <Fade left delay={0.3}>
                                    <li key={`homepage-questions-${index}`}>
                                        <span className="list__title">{item.question ? item.question : ""}</span>
                                        <p className="list__description">
                                            {getAnswer(item.answer)}
                                        </p>
                                    </li>
                                </Fade>
                            ))}
                        </ul>
                    </div>
                    {items && items.length > 3 && (
                        <div className='homepage__container-view-more'>
                            <a data-testid="btnQuestions" className={`link ${openMore && 'open'}`} onClick={changeView}>{openMore ? 'Ver menos' : 'Ver más'}
                            </a>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}